import { UsersInput, UsersOutput } from "@/interfaces/users";
import { BaseService, QueryParams } from "./BaseService";
import { AppManager } from "./AppManager";

export class UsersService extends BaseService<UsersInput, UsersOutput> {
  constructor() {
    super();
    this.path = "users";
  }

  async getUserMe(
    queryParams?: QueryParams,
    options?: RequestInit
  ): Promise<UsersOutput> {
    const url = `${this.path}/me/`;

    let user = AppManager.getInstance().getUser();

    if (user) {
      return user;
    }

    user = (await this.request(url, {
      ...options,
      queryParams,
      method: "GET",
    })) as UsersOutput;

    AppManager.getInstance().setUser(user);

    return user;
  }
}
